import React from "react";
import { useTranslation } from "react-i18next";
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';


/**
 * @Description this page AI Library Action Configuration Form
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRender - variable render
 * @Returns     div element
 * @Author      Kerem Karadeniz
 */
function NormalizeMesaure({ action, variables, setOpenVariable }) {
    const { t } = useTranslation();
    const label = "CONTENT.CONFIGURATION-FORM.PRE-PROCESSING.";

    return (
        <div>
            <div className="form-element">
                {t(label + "COLUMN")}
                <TextInput
                    action={action}
                    inputName="column"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired={false}
                />
            </div>
        </div>
    );
}

export default NormalizeMesaure;